import { routeTracker } from '@opengov/app-core/analytics/routeTracker';
import { IActionTransformFilter } from '@opengov/app-core/analytics/types';

import { storyListRoute, storyViewRoute } from './stories/routes';

// No compose-app actions left to track — storyList/storyView effects were
// retired (their success actions no longer dispatch). Kept as an empty list
// so the AnalyticsModule wiring in store.ts stays valid.
export const actionsToTrack: string[] = [];

export const actionTransformFilters: IActionTransformFilter[] = [routeTracker([storyListRoute, storyViewRoute])];
